import type { Event } from '@models/Event'

import { request } from '../../../gateways/api'

export { fetchProjectLog }

const fetchProjectLog = async ({ id }: { id?: string }): Promise<Event[]> => {
  const result = await request({
    url: `/rest/project/${id}/event`,
    method: 'GET',
  })

  return result
}
